// import PropTypes from "prop-types";
// import React from "react";
import styled from "styled-components";

import { Header1 } from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

export const DivHeaderPositioning = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  left: 0;
  justify-content: center;
  position: absolute;
  top: 0;
  width: 100%;
`;

export const Header1Hero = styled(Header1)`
  @media screen and (min-width: ${getSize(
      "tablet720"
    )}) and (max-width: 767px) {
    margin-top: 22px;
  }
  @media screen and (min-width: ${getSize("tablet720")}) {
    white-space: nowrap;
  }
`;
